import { BaseService } from '../base';

export type AccountValidationRules = {
  agencyDigitPattern: string;
  accountDigitPattern: string;
  agencyDigitMaxLength: number;
  accountDigitMinLength: number;
  accountDigitMaxLength: number;
};

export type PaymentType = {
  productCode: string;
  productVersion: string;
  code: string;
  description: string;
  /**
   * Valor canônico da coluna `BillingMethod` da DataTable do InsureMO: PIX,
   * CARTAO_CREDITO, BOLETO_PIX, FICHA_COMPENSACAO ou DEBITO_CONTA.
   *
   * É por ele que a tela decide comportamento. Casar pela `description`
   * quebraria em silêncio se alguém renomeasse a linha no InsureMO.
   */
  billingMethod?: string;
  bankCode?: string;
  accountValidationRules?: AccountValidationRules;
};

export type PaymentTypesResponse = PaymentType[];

export type ProductType =
  | 'HOME_INSURANCE'
  | 'BUSINESS_INSURANCE'
  | 'CAPITAL_GLOBAL'
  | string;

export class PaymentTypesService extends BaseService {
  async getPaymentTypes(productType: ProductType): Promise<{
    success: boolean;
    data?: PaymentTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/services/payment-type/${productType}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<PaymentTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de pagamento',
      };
    }
  }
}

export const paymentTypesService = new PaymentTypesService();
